/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Disconnected_External_Failed_DescInputs */



/**
* | output |
* | --- |
* | "{provider} revoked the connection on its own side, but disconnecting the integration here failed and may be incomplete. Check the connection and disconnect i..." |
*
* @param {Audit_Details_Integration_Disconnected_External_Failed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_disconnected_external_failed_desc = /** @type {((inputs: Audit_Details_Integration_Disconnected_External_Failed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Disconnected_External_Failed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.provider} hat die Verbindung auf eigener Seite widerrufen, das Trennen der Integration hier ist jedoch fehlgeschlagen und könnte unvollständig sein. Bitte die Verbindung prüfen und die Integration manuell trennen, falls sie noch aufgeführt ist.`)
	return /** @type {LocalizedString} */ (`${i?.provider} revoked the connection on its own side, but disconnecting the integration here failed and may be incomplete. Check the connection and disconnect it manually if it is still listed.`)
});